import { type IValidator } from './';

export class TimeValidator implements IValidator {
    status: string = '';
    statusType: 'info' | 'warning' | 'error' | 'na' = 'error';
    value?: string;
    format: string = 'h:m:s';
    hourIndex: number | null = null;
    minuteIndex: number | null = null;
    secondIndex: number | null = null;
    millisecondsIndex: number | null = null;

    public constructor(format: string) {
        this.setFormat(format);
    }

    Status(): string {
        return this.status;
    }

    StatusType(): 'info' | 'warning' | 'error' | 'na' {
        return this.statusType;
    }

    Value(): string {
        return this.value as string;
    }

    private setFormat(value: string): void {
        // Remove all non-date characters and split the string into an array
        // this should always give us 3 values, if not the format is invalid. The values can contain y, yy yyy etc. but that doesnt matter.
        // we only need to know what order the values are in, and that it contains all y m d values
        const values: string[] = value
            .toLowerCase()
            .replace(/[^hmsf]/g, ':')
            .split(':')
            .filter((i) => i);

        // Find the index of the y m d values
        values.forEach((v, i) => {
            if (v.includes('h')) {
                this.hourIndex = i;
            } else if (v.includes('m')) {
                this.minuteIndex = i;
            } else if (v.includes('s')) {
                this.secondIndex = i;
            } else if (v.includes('f')) {
                this.millisecondsIndex = i;
            }
        });

        // We do the same with milliseconds, but we dont care about the order of the values

        this.format = value;
    }

    /**
     * Validatae the cell value as a date
     * @param cellvalue
     * @returns boolean
     */
    Validate(cellvalue: string): boolean {
        if (this.format === '') {
            this.status = 'timevalidator.noformat';
            this.statusType = 'warning';
            return false;
        }

        const _value: number[] = cellvalue
            .replace(/\D/g, ':')
            .split(':')
            .filter((i) => i)
            .map((i) => parseInt(i));

        if (this.hourIndex == null || this.minuteIndex == null || this.secondIndex == null) {
            this.status = 'timevalidator.noformat';
            this.statusType = 'error';
            return false;
        }

        if (_value.length == 4 && this.millisecondsIndex == null) {
            this.status = 'timevalidator.ignoremillisecond';
            this.statusType = 'warning';
            return false;
        }

        if (this.hourIndex && (_value[this.hourIndex] < 0 || _value[this.hourIndex] > 23)) {
            this.status = 'timevalidator.invalidhour';
            this.statusType = 'error';
            return false;
        }

        if (this.minuteIndex && (_value[this.minuteIndex] < 0 || _value[this.minuteIndex] > 59)) {
            this.status = 'timevalidator.invalidminute';
            this.statusType = 'error';
            return false;
        }

        if (this.secondIndex && _value[this.secondIndex] < 0 && _value[this.secondIndex] > 59) {
            this.status = 'timevalidator.invalidsecond';
            this.statusType = 'error';
            return false;
        }

        if (this.millisecondsIndex && (_value[this.millisecondsIndex] < 0 || _value[this.millisecondsIndex] > 999)) {
            this.status = 'timevalidator.invalidmillisecond';
            this.statusType = 'error';
            return false;
        }

        return true;
    }
}
